import { ICities, INeightborhoods } from "./interfaces";

export function normalizeSearchText(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function findNeighborhoodByQuery(
  query: string,
  neighborhoods: INeightborhoods[],
  preferredCity?: string | null
): INeightborhoods | undefined {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) {
    return undefined;
  }

  const pool = preferredCity
    ? neighborhoods.filter(
        (item) =>
          normalizeSearchText(item.city) === normalizeSearchText(preferredCity)
      )
    : neighborhoods;

  const exactMatch = pool.find(
    (item) => normalizeSearchText(item.neighborhood) === normalizedQuery
  );
  if (exactMatch) {
    return exactMatch;
  }

  return pool.find((item) =>
    normalizeSearchText(item.neighborhood).includes(normalizedQuery)
  );
}

export function findCityByQuery(
  query: string,
  cities: ICities[],
  fallbackCities: ICities[] = []
): ICities | undefined {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) {
    return undefined;
  }

  const pool = cities.length > 0 ? cities : fallbackCities;

  const exactMatch = pool.find(
    (item) => normalizeSearchText(item.city) === normalizedQuery
  );
  if (exactMatch) {
    return exactMatch;
  }

  return pool.find((item) => {
    const cityLabel = normalizeSearchText(`${item.city} ${item.UF}`);
    return (
      normalizeSearchText(item.city).includes(normalizedQuery) ||
      cityLabel.includes(normalizedQuery)
    );
  });
}
